@if(control()) {
  @if(label()) {
    <label class="form-label" >{{ label() }}</label>
  }
  @switch (type()) {
    @case ('date') {
      <div class="form-input">
        <input
          type="date"
          [max]="max() ? max() : ''"
          [min]="min() ? min() : ''"
          (change)="handleChangeInput($event)"
          [readonly]="readOnly()"
          [style.cursor]="notAllowed() ? 'not-allowed' : 'default'"
          [formControl]="control()"
          [placeholder]="placeholder()"
          [value]="formatDateForInput(value())"
        />
      </div>
    }
    @case ('dateMask') {
    <div class="form-input">
    <input
      matInput
      [matDatepicker]="picker"
      [min]="toDate(min())"
      [max]="toDate(max())"
      [readonly]="readOnly()"
      [style.cursor]="notAllowed() ? 'not-allowed' : 'default'"
      [formControl]="control()"
      (dateChange)="handleDateChange($event.value)"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </div>
}
    @case ('document') {
      <div class="form-input">
        <input
          type="text"
          [value]="documentDisplayValue()"
          [placeholder]="placeholder()"
          (input)="handleDocumentInput($event)"
          (blur)="handleBlurInput()"
        />
      </div>
    }
    @case ('postalCode') {
      <div class="form-input">
        <input
          type="text"
          [formControl]="control()"
          (change)="handleChangeInput($event)"
          [placeholder]="placeholder()"
          mask="00.000-000"
        />
      </div>
    }
    @case ('car') {
      <div class="form-input">
        <input
          type="text"
          [formControl]="control()"
          (change)="handleChangeInput($event)"
          [placeholder]="placeholder()"
          mask="SS-0000000-AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA"
        />
      </div>
    }
    @case ('number') {
      <div class="form-input">
        <input
          type="number"
          [formControl]="control()"
          (change)="handleChangeInput($event)"
          [placeholder]="placeholder()"
          [readonly]="readOnly()"
          [style.cursor]="notAllowed() ? 'not-allowed' : 'default'"
        />
      </div>
    }
    @case ('naturalNumber') {
      <div class="form-input">
        <input
          type="number"
          [formControl]="control()"
          (change)="handleChangeInput($event)"
          [placeholder]="placeholder()"
          (keypress)="checkNaturalNumber($event)"
          [min]="0"
          [readonly]="readOnly()"
        />
      </div>
    }
    @case ('phoneNumber') {
      <div class="form-input">
        <input
          type="text"
          [formControl]="control()"
          (change)="handleChangeInput($event)"
          [placeholder]="placeholder()"
          mask="(00) 0 0000-0000||(00) 0000-0000"
        />
      </div>
    }
    @case ('textarea') {
      <div class="form-input" style="height: 100%;">
        <textarea
          type="text"
          [formControl]="control()"
          (change)="handleChangeInput($event)"
          [placeholder]="placeholder()"
        ></textarea>
      </div>
    }
    @case ('checkbox') {
      <mat-checkbox
        [formControl]="control()"
        color="primary"
        style="font-size: 14px;font-weight: 400;color: #53565A;"
      >{{ label() }}</mat-checkbox>
    }
    @case ('select') {
      <div class="form-input">
        <select [formControl]="control()" (change)="handleChangeInput($event)">
          <option value=""> {{ placeholder() }} </option>
          @for (option of options(); track option; let i = $index) {
            <option [value]="option.value ? option.value : option"> {{ option.name ? option.name : option }} </option>
          }
        </select>
      </div>
    }
    @case ('color') {
      <div class="form-input">
        <input
          type="color"
          [formControl]="control()"
          (change)="handleChangeInput($event)"
          [placeholder]="placeholder()"
        />
      </div>
    }
    @case ('boolean') {
      <mat-slide-toggle
        [formControl]="control()"
        [checked]="control().value"
        (change)="handleChangeInput($event)"
        color="primary"
      />
    }
    @default {
      <div class="form-input">
        <input
          type="text"
          [formControl]="control()"
          (change)="handleChangeInput($event)"
          [placeholder]="placeholder()"
          [readonly]="readOnly()"
          [style.cursor]="notAllowed() ? 'not-allowed' : 'default'"
          [maxlength]="maxLength()"
          [minlength]="minLength()"
        />
      </div>
    }
  }

  @if (control()?.value) {
    @switch (type()) {
      @case ('car') {
        @if (control().touched && control()?.getError('mask')) {
          <p class="alert">{{ 'VALIDATORS.CAR' | translate }}</p>
        }
      }
      @case ('email') {
        @if (control().touched && control()?.getError('email')) {
          <p class="alert">{{ 'VALIDATORS.EMAIL' | translate }}</p>
        }
      }
      @case ('phoneNumber') {
        @if (control().touched && control()?.getError('mask')) {
          <p class="alert">{{ 'VALIDATORS.TELEPHONE' | translate }}</p>
        }
      }
      @case ('phoneNumber') {
        @if (control().touched && control()?.getError('mask')) {
          <p class="alert">{{ 'VALIDATORS.POSTAL-CODE' | translate }}</p>
        }
      }
      @case ('document') {
        @if (control().touched && isDocumentInvalid) {
          <p class="alert">{{ 'VALIDATORS.DOCUMENT' | translate }}</p>
        }
      }
      @case ('number') {
        @if (errorMessage) {
          <p class="alert">{{ errorMessage }}</p>
        } @else {
          @if (control().touched && control()?.getError('min')) {
            <p class="alert">{{ 'VALIDATORS.MIN' | translate: { min: control()?.errors.min.min } }}</p>
          } @else {
            @if (control().touched && control()?.getError('max')) {
              <p class="alert">{{ 'VALIDATORS.MAX' | translate: { max: control()?.errors.max.max } }}</p>
            }
          }
        }
      }
      @case ('naturalNumber') {
        @if (errorMessage) {
          <p class="alert">{{ errorMessage }}</p>
        } @else {
          @if (control().touched && control()?.getError('min')) {
            <p class="alert">{{ 'VALIDATORS.MIN' | translate: { min: control()?.errors.min.min } }}</p>
          }
          @if (control().touched && control()?.getError('max')) {
            <p class="alert">{{ 'VALIDATORS.MAX' | translate: { max: control()?.errors.max.max } }}</p>
          }
        }
      }
      @case ('text') {
        @if (errorMessage) {
          <p class="alert">{{ errorMessage }}</p>
        } @else {
          @if (control().touched && control()?.getError('minlength')) {
            <p class="alert">{{ 'VALIDATORS.MIN-LENGTH' | translate: { minLength: control()?.errors.minlength.requiredLength } }}</p>
          }
          @if (control().touched && control()?.getError('maxlength')) {
            <p class="alert">{{ 'VALIDATORS.MAX-LENGTH' | translate: { maxLength: control()?.errors.maxlength.requiredLength } }}</p>
          }
          @if (control().touched && control()?.getError('pattern')) {
            <p class="alert">{{ 'VALIDATORS.REQUIRED-PATTERN' | translate: { pattern: control()?.errors.pattern.requiredPattern } }}</p>
          }
        }
      }
      @case ('textarea') {
        @if (errorMessage) {
          <p class="alert">{{ errorMessage }}</p>
        } @else {
          @if (control().touched && control()?.getError('minlength')) {
            <p class="alert">{{ 'VALIDATORS.MIN-LENGTH' | translate: { minLength: control()?.errors.minlength.requiredLength } }}</p>
          }
          @if (control().touched && control()?.getError('maxlength')) {
            <p class="alert">{{ 'VALIDATORS.MAX-LENGTH' | translate: { maxLength: control()?.errors.maxlength.requiredLength } }}</p>
          }
          @if (control().touched && control()?.getError('pattern')) {
            <p class="alert">{{ 'VALIDATORS.REQUIRED-PATTERN' | translate: { pattern: control()?.errors.pattern.requiredPattern } }}</p>
          }
        }
      }
    }
  } @else {
    @if (control().touched && control().invalid) {
      <p class="alert">{{ 'VALIDATORS.REQUIRED' | translate}}</p>
    }
  }
} @else {
  <label class="form-label" >{{ label() }}</label>
  @switch (type()) {
    @case ('document') {
      <div class="form-input">
        <input
          [type]="type()"
          [value]="value() || ''"
          [placeholder]="placeholder()"
          mask="000.000.000-00||AA.AAA.AAA/AAAA-00"
        />
      </div>
    }
    @default {
      <div class="form-input">
        <input
          [type]="type()"
          [value]="type() === 'date' ? formatDateForInput(value()) : (value() || '')"
          [placeholder]="placeholder()"
        />
      </div>
    }
  }
}
<!-- @defer(when !(loading$ | async)) {
}
@placeholder(minimum 500ms) {
  <label class="form-label" >{{ label() }}</label>
  <div class="skeleton-container">
    <div class="skeleton skeleton-input"></div>
  </div>
} -->
